import type { User } from '@/types/auth';

export interface AuthStorage {
  getToken: () => Promise<string | null>;
  setToken: (token: string) => Promise<void>;
  removeToken: () => Promise<void>;
  getRefreshToken: () => Promise<string | null>;
  setRefreshToken: (token: string) => Promise<void>;
  removeRefreshToken: () => Promise<void>;
  getUser: () => Promise<User | null>;
  setUser: (user: User) => Promise<void>;
  removeUser: () => Promise<void>;
  removeYsiSessionID: () => Promise<void>;
}

// Add guarantor prefix to all storage keys
const GUARANTOR_PREFIX = 'guarantor';

export const webStorage: AuthStorage = {
  async getToken() {
    return localStorage.getItem(`${GUARANTOR_PREFIX}_auth_token`);
  },
  async setToken(token: string) {
    localStorage.setItem(`${GUARANTOR_PREFIX}_auth_token`, token);
  },
  async removeToken() {
    localStorage.removeItem(`${GUARANTOR_PREFIX}_auth_token`);
  },
  async getRefreshToken() {
    return localStorage.getItem(`${GUARANTOR_PREFIX}_refresh_token`);
  },
  async setRefreshToken(token: string) {
    localStorage.setItem(`${GUARANTOR_PREFIX}_refresh_token`, token);
  },
  async removeRefreshToken() {
    localStorage.removeItem(`${GUARANTOR_PREFIX}_refresh_token`);
  },
  async getUser() {
    const userStr = localStorage.getItem(`${GUARANTOR_PREFIX}_user`);
    return userStr ? JSON.parse(userStr) as User : null;
  },
  async setUser(user: User) {
    localStorage.setItem(`${GUARANTOR_PREFIX}_user`, JSON.stringify(user));
  },
  async removeUser() {
    localStorage.removeItem(`${GUARANTOR_PREFIX}_user`);
  },
  async removeYsiSessionID() {
    document.cookie = `YSISessionID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}; 